module.exports = __webpack_public_path__ + "img/icn_undo.9c95af62.svg";